<form #searchForm="ngForm" [formGroup]="form" class="table-search-form">
  <div class="input-group search-group">
    <div class="input-group-btn" dropdown="" *ngIf="config.options">
      <button class="btn btn-default" type="button" dropdownToggle>{{ 'search.options' | translate }} <span
          class="caret"></span>
      </button>
      <ul *dropdownMenu class="dropdown-menu">
        <li [ngClass]="{ 'active': searchBy.field == option.field }" *ngFor="let option of config.options"><a
            (click)="onSearchBy(option)">{{ option.translate | translate }}</a></li>

        <ng-container *ngIf="config.advanced">
          <li role="separator" class="divider"></li>
          <li [ngClass]="{ 'active': searchBy == 'advanced'}"><a (click)="onSearchBy('advanced')">{{ 'search.advanced' |
              translate }}</a></li>
        </ng-container>
      </ul>
    </div>

    <ng-container *ngIf="!advancedSearch; else advancedSearchTemplate">
      <input placeholder="{{ config.placeholder }} {{ searchBy.translate | translate | lowercase }}"
        class="form-control" [formControl]="form.controls[searchBy.field]" (keyup)="onSearch(searchForm)" />
    </ng-container>

    <span class="input-group-btn">
      <button class="btn btn-default" type="button" [ngClass]="{ 'btn-primary' : form.dirty }" [disabled]="!form.dirty"
        (click)="onManualSearch()">
        <em class="icon-magnifier"></em>
      </button>
    </span>
  </div>
</form>
<ng-template #advancedSearchTemplate>
  <ng-container *ngFor="let option of config.options | excludeFilter:'exclude'; let i = index;">
    <span class="input-group-spacer" *ngIf="i > 0"></span>
    <input type="text" placeholder="{{ option.translate | translate }}" class="form-control"
      [formControl]="form.controls[option.field]" (keyup)="onSearch(searchForm)">
  </ng-container>
</ng-template>